// Sri Lanka products: imported trips only (33 Thrillophilia sources + 1 group tour), no generic package set.
import { tropicalSriLankaKandySigiriyaBentotaProduct } from './tropicalSriLankaKandySigiriyaBentotaData';
import { fullyLoadedSriLankaYalaSafariProduct } from './fullyLoadedSriLankaYalaSafariData';
import { exoticSriLankaCouplesKandyBentotaProduct } from './exoticSriLankaCouplesKandyBentotaData';
import { sriLankaGroupTourSigiriyaEllaMirissaProduct } from './sriLankaGroupTourSigiriyaEllaMirissaData';
import { luxurySriLankaKandyBentotaColomboProduct } from './luxurySriLankaKandyBentotaColomboData';
import { sweetEscapeSriLankaKandyBentotaProduct } from './sweetEscapeSriLankaKandyBentotaData';
import { offbeatSriLankaDambullaNuwaraEliyaProduct } from './offbeatSriLankaDambullaNuwaraEliyaData';
import { sriLankaFamilyGetawayKandyBentotaProduct } from './sriLankaFamilyGetawayKandyBentotaData';
import { teaCountrySriLankaHattonKandyProduct } from './teaCountrySriLankaHattonKandyData';
import { grandSriLankaTenDaysDambullaYalaBentotaProduct } from './grandSriLankaTenDaysDambullaYalaBentotaData';
import { scenicSriLankaKandyEllaGalleProduct } from './scenicSriLankaKandyEllaGalleData';
import { sriLankanDelightSigiriyaKandyBentotaProduct } from './sriLankanDelightSigiriyaKandyBentotaData';
import { sriLankaOdysseyKandyNuwaraEliyaBentotaProduct } from './sriLankaOdysseyKandyNuwaraEliyaBentotaData';
import { highlightsOfSriLankaKandyYalaBentotaProduct } from './highlightsOfSriLankaKandyYalaBentotaData';
import { sriLankaHoneymoonKandyNuwaraEliyaBentotaProduct } from './sriLankaHoneymoonKandyNuwaraEliyaBentotaData';
import { splendoursOfSriLankaKandyNuwaraEliyaMirissaProduct } from './splendoursOfSriLankaKandyNuwaraEliyaMirissaData';
import { sriLankaSigiriyaEllaBentotaSevenDaysProduct } from './sriLankaSigiriyaEllaBentotaSevenDaysData';
import { splendoursOfSriLankaSigiriyaMirissaSevenDaysProduct } from './splendoursOfSriLankaSigiriyaMirissaSevenDaysData';
import { sriLankaTajBentotaColomboProduct } from './sriLankaTajBentotaColomboData';
import { tropicalSriLankaSuperDeluxeKandySigiriyaBentotaProduct } from './tropicalSriLankaSuperDeluxeKandySigiriyaBentotaData';
import { fullyLoadedSriLankaSuperDeluxeYalaJetwingProduct } from './fullyLoadedSriLankaSuperDeluxeYalaJetwingData';
import { exoticSriLankaSuperDeluxeCouplesBentotaProduct } from './exoticSriLankaSuperDeluxeCouplesBentotaData';
import { sriLankaRetreatSuperDeluxeKandyBentotaProduct } from './sriLankaRetreatSuperDeluxeKandyBentotaData';
import { sriLankaHighlightsKandyBentotaCentaraProduct } from './sriLankaHighlightsKandyBentotaCentaraData';
import { sriLankaGroupTourKandyEllaBentotaProduct } from './sriLankaGroupTourKandyEllaBentotaData';
import { sriLankaInSerenityKandyNuwaraEliyaBentotaProduct } from './sriLankaInSerenityKandyNuwaraEliyaBentotaData';
import { sriLankaRetreatKandyBentotaFiveDaysProduct } from './sriLankaRetreatKandyBentotaFiveDaysData';
import { sriLankaLeisureKandyBentotaTurtlesProduct } from './sriLankaLeisureKandyBentotaTurtlesData';
import { sriLankaRetreatKandyBentotaGalleProduct } from './sriLankaRetreatKandyBentotaGalleData';
import { sriLankaHillsNuwaraEliyaKandyProduct } from './sriLankaHillsNuwaraEliyaKandyData';
import { sriLankanSplendourKandyNuwaraEliyaBentotaFiveDaysProduct } from './sriLankanSplendourKandyNuwaraEliyaBentotaFiveDaysData';
import { sriLankaWeekendBentotaColomboProduct } from './sriLankaWeekendBentotaColomboData';
import { jewelsOfSriLankaKandyBentotaColomboProduct } from './jewelsOfSriLankaKandyBentotaColomboData';
import { sriLankaShortBreakKandyColomboProduct } from './sriLankaShortBreakKandyColomboData';

export const sriLankaProducts = [
  tropicalSriLankaKandySigiriyaBentotaProduct,
  fullyLoadedSriLankaYalaSafariProduct,
  exoticSriLankaCouplesKandyBentotaProduct,
  sriLankaGroupTourSigiriyaEllaMirissaProduct,
  luxurySriLankaKandyBentotaColomboProduct,
  sweetEscapeSriLankaKandyBentotaProduct,
  offbeatSriLankaDambullaNuwaraEliyaProduct,
  sriLankaFamilyGetawayKandyBentotaProduct,
  teaCountrySriLankaHattonKandyProduct,
  grandSriLankaTenDaysDambullaYalaBentotaProduct,
  scenicSriLankaKandyEllaGalleProduct,
  sriLankanDelightSigiriyaKandyBentotaProduct,
  sriLankaOdysseyKandyNuwaraEliyaBentotaProduct,
  highlightsOfSriLankaKandyYalaBentotaProduct,
  sriLankaHoneymoonKandyNuwaraEliyaBentotaProduct,
  splendoursOfSriLankaKandyNuwaraEliyaMirissaProduct,
  sriLankaSigiriyaEllaBentotaSevenDaysProduct,
  splendoursOfSriLankaSigiriyaMirissaSevenDaysProduct,
  sriLankaTajBentotaColomboProduct,
  tropicalSriLankaSuperDeluxeKandySigiriyaBentotaProduct,
  fullyLoadedSriLankaSuperDeluxeYalaJetwingProduct,
  exoticSriLankaSuperDeluxeCouplesBentotaProduct,
  sriLankaRetreatSuperDeluxeKandyBentotaProduct,
  sriLankaHighlightsKandyBentotaCentaraProduct,
  sriLankaGroupTourKandyEllaBentotaProduct,
  sriLankaInSerenityKandyNuwaraEliyaBentotaProduct,
  sriLankaRetreatKandyBentotaFiveDaysProduct,
  sriLankaLeisureKandyBentotaTurtlesProduct,
  sriLankaRetreatKandyBentotaGalleProduct,
  sriLankaHillsNuwaraEliyaKandyProduct,
  sriLankanSplendourKandyNuwaraEliyaBentotaFiveDaysProduct,
  sriLankaWeekendBentotaColomboProduct,
  jewelsOfSriLankaKandyBentotaColomboProduct,
  sriLankaShortBreakKandyColomboProduct
];
export const sriLankaTours = [];
export const sriLankaBySlug = {};
